export default [
  /* Leads */
  {
    path: '/produtoForca',
    name: 'Produto Forca',
    meta: {
      descricao: 'Produto Força'
    },
    component: () => import('@/pages/produto_forca/ProdutoForca')
  }
]
